import React, { FC } from 'react';
import { GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  PAGE_LOCATIONS,
  buildPayloadUrl,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

export type CoursePacksTileProps = {
  tile: TypeAccountNavTileFields;
  hasCourses: boolean;
};

const CoursePacksTile: FC<CoursePacksTileProps> = ({ tile, hasCourses }) => {
  if (!hasCourses) return null;

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields),
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.COURSE_PACKS_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <UniversalLink
          link={tile.buttonLink}
          classes="underline lg:text-h4 text-base col-span-1 justify-end mb-4 text-blue-deep font-bold"
          onClick={sendItemClickedEvent}
        />
      }
    />
  );
};

export default React.memo(CoursePacksTile);
